
<template>
  <div>
    <!-- <button @click="loadData">Load Data</button> -->
    <!-- <ul>
      <li v-for="item in loadedData" :key="item.Id">{{ item.Name }}</li>
    </ul> -->
    <CCard>
      <CInput type="text" placeholder="Search text" v-model.lazy="SearchQuery" />
    <CDataTable
      class="d-sm-down-none"
      :items="user.validTo < currentDate ? loadedData.slice(0, 5) : loadedData"
      :fields="fields"
      items-per-page-select
      :items-per-page="small ? 5 : 10"
      clickable-rows
      pagination
    >
      <template #ID="{ item }">
        <td>
          <strong> {{ item.Id }} </strong>
        </td>
      </template>

      <template #Profile="{ item }">
        <td>
          <img
            v-if="item.profileImagePath == null"
            style="
              border: 1px solid #eee;
              width: 60px;
              height: 60px;
              border-radius: 50%;
              object-fit: cover;
            "
            src="../assets/img/default.png"
            class="grey lighten-2 mt-2"
          />

          <img
            v-else
            style="
              border: 3px solid #ddd;
              background: #fff;
              width: 60px;
              height: 60px;
              border-radius: 50%;
              object-fit: cover;
            "
            :src="getPicChild(item)"
            class="grey lighten-2 mt-2"
          />
        </td>
      </template>

      <template #StudentDetail="{ item }">
        <td>
          <h6 style="color: #1e109c" class="text-uppercase">
            {{ item.Name }}
          </h6>
          <CBadge v-if="item.Status == 'active'" color="success">Active</CBadge>
          <CBadge v-else-if="item.Status == 'inactive'" color="danger"
            >InActive</CBadge
          >
          <CBadge v-else color="warning"></CBadge>
          <div class="small text-muted">
            Parent Name : {{ item.ParentName }} / {{ item.ParentEmail }}
          </div>
          <div class="small text-muted">Grade : {{ item.Grade }}</div>
          <div class="small text-muted">Class : {{ item.Class }}</div>
          <div class="small text-muted">Parent H/P : {{ item.Phone }}</div>
          <div class="small text-muted">
            Registered : {{ item.Register | moment(" MMM YYYY") }}
          </div>
          <div class="small text-muted">
            <CBadge
              color="warning"
              class="ml-auto"
              v-if="item.Rate == 'monthly'"
              >{{ item.Rate }}</CBadge
            >
            <CBadge color="info" class="ml-auto" v-else>{{ item.Rate }}</CBadge>
          </div>
        </td>
      </template>

      <template #PackageSubjects="{ item }">
        <!-- <td>
              <CRow v-for="su in item.Packages" :key="su.Id">
              <CCol sm="12"> {{ su.Name }} - RM {{ su.StudentFee }}
                <br />
              List Subject: <br />
                <ul v-for="sub in su.Subjects" v-bind:key="sub.Id">
                <li><strong><i>{{ sub.Name }}</i></strong></li>
                  </ul></CCol>
            </CRow>
            </td> -->

        <td>
          <CRow v-for="su in item.Packages" :key="su.Id">
            <CCol sm="12"
              ><ul>
                <li>{{ su.Name }} - RM {{ su.StudentFee }}</li>
              </ul>
            </CCol>
            <!-- <CCol sm="6">
                  List Subject: <br />
                <ul v-for="sub in su.Subjects" v-bind:key="sub.Id">
                <li><strong><i>{{ sub.Name }}</i></strong></li>
                  </ul>
                </CCol> -->
          </CRow>
        </td>
      </template>

      <template #SubjectClass="{ item }">
        <td>
          <div v-for="su in item.Packages" :key="su.Id">
            <ul v-for="sub in su.Subjects" v-bind:key="sub.Id">
              <li>
                {{ sub.Name }} <br />
                Teacher: <i class="small text-muted"> {{ sub.Teacher }}</i>
              </li>
            </ul>
          </div>
        </td>
      </template>

      <template #Cost="{ item }">
        <td>
          Discount:
          <strong style="color: #1e109c">
            <span v-if="item.Discount == null">RM 0</span
            ><span v-else>RM {{ item.Discount }}</span></strong
          >
          <br />
          Total Fee:
          <strong style="color: #1e109c"
            >RM {{ item.TotalFee - item.Discount }}</strong
          >
        </td>
      </template>

      <template #Action="{ item }">
        <td>
          <CDropdown toggler-text="Action" class="m-2 btn-act" color="primary">
            <CDropdownItem @click="OpenStudentModal(item)"
              >Detail Student</CDropdownItem
            >
            <CDropdownItem @click="OpenDiscountModal(item)"
              >Add Discount</CDropdownItem
            >
            <CDropdownItem @click="OpenAssignPackageModal(item)"
              >Assign Package</CDropdownItem
            >
            <hr />
            <CDropdownItem @click="OpenUpdateStudent(item)"
              >Edit Student</CDropdownItem
            >

            <CDropdownItem @click="OpenInactiveModal(item)"
              >Delete Student</CDropdownItem
            >
          </CDropdown>
        </td>
      </template>
    </CDataTable>
    <div v-if="isLoading">Loading...</div>
    </CCard>
    
  </div>
</template>


<script>
import _ from "lodash";
import Vue from "vue";
Vue.use(require("vue-moment"));
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import $ from "jquery";

import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

import VueJsonToCsv from "vue-json-to-csv";
import VuePapaParse from "vue-papa-parse";
Vue.use(VuePapaParse);
import download from "downloadjs";
Vue.use(VuejsDialog);
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
export default {
  data() {
    return {
      loadedData: [],
      remainingData: [],
      isLoading: false,
      user: {},
      check: {},
      currentDate: new Date().toISOString().substring(0, 10),
      SearchQuery: "",
      FilteredStudents: [],
      small: "",

      fields: [
        { key: "ID" },
        { key: "Profile" },
        { key: "StudentDetail" },
        { key: "PackageSubjects" },
        { key: "SubjectClass" },
        { key: "Cost" },
        { key: "Action" },
      ],
    };
  },
  computed: {
    
  },
  mounted() {
    this.SessionUserIdNo();
    this.loadData();
  },
  methods: {
    SessionUserIdNo() {
      return this.$API
        .get(this.$LoginUserDetailAdmin, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetCheckTc(this.user.tuitioncenter);
          }
        });
    },
    GetCheckTc(tuitioncenter) {
      return this.$API
        .get(this.$GetCheckTcPackage + "?TuitionCenterId=" + tuitioncenter, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.check = response.data;
          }
        });
    },
    getPicChild(item) {
      return "https://pickiddo.com" + item.profileImagePath;
    },
    async loadData() {
      try {
        // Display a loading indicator
        this.Busy = true;
        this.$API;
        this.$API
          .get(this.$ViewStudentLoad + "?limit=10", { withCredentials: true })
          .then((response) => {
            if (response.status == 200 && response.data != null) {
              this.loadedData = response.data;
              // this.loadedData = this.loadedData.slice(0, this.user.totalStudent);
              // this.getPicChild(this.loadedData);
              this.FilteredStudents = this.loadedData;
              this.getPicChild(this.loadedData);
              this.fetchRemainingData();
              this.Busy = false;
            }
          });
      } catch (error) {
        // Handle any errors that occur during data fetching
        console.error(error);
        this.isLoading = false;
      }
    },

    fetchRemainingData() {
      const initialLimit = 10; // Initial limit for the initial data in loadData()
      const totalData = this.user.totalStudent - initialLimit; // Calculate the remaining number of data to load
      let remainingCount = totalData;
      let offset = initialLimit; // Initial offset for pagination

      const fetchNextChunk = () => {
        const limit = Math.min(remainingCount, 10); // Set the limit to either 10 or the remaining count, whichever is smaller

        this.$API
          .get(`${this.$ViewStudentLoad}?limit=${limit}&offset=${offset}`, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status === 200 && response.data !== null) {
              const remainingData = response.data;

              // Append the fetched data to the existing loadedData array
              this.loadedData = [...this.loadedData, ...remainingData];
              // this.getPicChild(remainingData);

              remainingCount -= limit; // Decrease the remaining count by the limit

              if (remainingCount > 0) {
                offset += limit; // Increment the offset for the next chunk
                fetchNextChunk(); // Fetch the next chunk recursively
              } else {
                this.Busy = false; // All data has been loaded, set Busy to false
              }
            }
          })
          .catch((error) => {
            console.error(error);
            this.Busy = false; // Handle any errors and set Busy to false
          });
      };

      fetchNextChunk();
    },
  },
};
</script>

